<script setup lang="ts">
import { formatToFullVisibleAddress } from '@/utils/formatToFullVisibleAddress'

import type { AddressClient } from '@/api/modules/addresses/addresses.types'

const BORDER_VISIBLE_FLAT = 3

type Props = {
  address: AddressClient
  addressId: number
}

const props = defineProps<Props>()

// Проверка на то, что адрес вне зоны доставки
const isNotDeliveryAreaAddress = computed(() => {
  return !props.address.is_in_delivery_area
})

const correctAddressCityStreet = computed(() => {
  return formatToFullVisibleAddress(props.address, {
    street: false,
  })
})

const correctAddressHouseFlat = computed(() => {
  const { house, flat } = props.address

  // TODO: В будущем добавить валидацию для корректных полей квартиры, подъезда и.т.д
  return flat && flat.length <= BORDER_VISIBLE_FLAT
    ? `д. ${house}, кв. ${flat}`
    : `д. ${house}`
})

const city = computed(() => {
  const { city, alias } = props.address
  return `г. ${city || alias}`
})
</script>

<template>
  <the-radio :value="addressId" :disabled="isNotDeliveryAreaAddress">
    <div role="option" class="user-list-item">
      <div class="user-list-item__address">
        <div class="user-list-item__complete-address">
          <span class="user-list-item__street">
            {{ correctAddressCityStreet }}
          </span>

          <span class="user-list-item__house">
            {{ correctAddressHouseFlat }}
          </span>
        </div>

        <span class="user-list-item__city">
          {{ city }}
        </span>
      </div>
    </div>
  </the-radio>
</template>

<style scoped lang="scss">
.user-list-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  user-select: none;

  @include media('>=tablet') {
    width: 100%;
  }

  &__address {
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: 100%;
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
    color: var(--ui-color-sandy-950);
  }

  &__complete-address {
    display: flex;
    align-items: center;
    padding-right: 6px;
  }

  &__street {
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    word-break: break-all;
    -webkit-box-orient: vertical;
  }

  &__house {
    margin-left: 3px;
    white-space: nowrap;
  }

  &__city {
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    font-size: 12px;
    line-height: 16px;
    color: var(--ui-color-sandy-700);
    word-break: break-all;
    -webkit-box-orient: vertical;
  }
}
</style>
